import Vue from 'vue';
import App from './App.vue';
import router from './router.js';
import store from './store'

Vue.config.productionTip = false;

import Buefy from 'buefy';

// All options available at: https://buefy.org/documentation/constructor-options
Vue.use(Buefy, {
    defaultIconPack: 'fas'
});

import AsyncComputed from 'vue-async-computed';
Vue.use(AsyncComputed);

import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading, {
    props: {
        spinner: 'waveDots'
    },
    system: {
        throttleLimit: 500
    }
});

// import * as webix from "@xbs/webix-pro";
// import * as VueWebix from 'vue-webix';
// Vue.use(VueWebix);

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import VueQuill from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuill);

// Register a custom break blot so Shift+Enter inserts <br> instead of <p>
import Quill from 'quill';
let Embed = Quill.import('blots/embed');
class ShiftEnterBreak extends Embed {
    static create() { return document.createElement('br'); }
    static value() { return undefined; }
    length() { return 1; }
}
ShiftEnterBreak.blotName = 'break';
ShiftEnterBreak.tagName = 'BR';
Quill.register(ShiftEnterBreak, true);

// import Editor from 'vue-editor-js/src/index';
// Vue.use(Editor)

import VueMask from 'v-mask';
Vue.use(VueMask);

import JsonViewer from 'vue-json-viewer';
Vue.use(JsonViewer);

import VueGraph from 'vue-graph';
Vue.use(VueGraph);

import contenteditable from 'vue-contenteditable'
Vue.use(contenteditable);

import VueCurrencyFilter from 'vue-currency-filter';
Vue.use(VueCurrencyFilter,
    {
        symbol: '$',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: false
    });

import vueNumeralFilterInstaller from 'vue-numeral-filter';
Vue.use(vueNumeralFilterInstaller, { locale: 'en' });

import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);


import Notifications from '@/components/common/Notification';
Vue.use(Notifications);

import TIER from "./TIER/TIER";
import cardDefinitions from './constants/cards';

Vue.use(TIER, {
    router: router,
    cardDefinitions: cardDefinitions
});

import VueFilter from 'vue-filter';
Vue.use(VueFilter);

import { axiosInstance } from "./http_client";

const token = localStorage.getItem('token');
if (token) {
    console.log('Setting token.');
    axiosInstance.defaults.headers.common['Authorization'] = token;
}

axiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (err) {
    if (err.response.status === 401) {
        console.log('Received 401, signing out.');
        store.dispatch('signOut');
        if (router.currentRoute.path !== '/') router.push('/');
    }
    return Promise.reject(err);
});

import VueNativeSock from 'vue-native-websocket'
let wwsUrl = 'wss://api.my247ed.com';
if (location.hostname === 'localhost')
    wwsUrl = 'ws://localhost:3000';
else if (location.hostname === 'staging-portal.my247ed.com')
    wwsUrl = 'wss://staging-api.my247ed.com';
Vue.use(VueNativeSock, wwsUrl, { format: 'json', reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 3000 });

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

Vue.filter('tel', function (phone) {
    if (phone) {
        return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    } else {
        return 'N/A';
    }
});

Vue.filter('capitalize', function (value) {
    if (value) {
        return value.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
    } else {
        return '';
    }
});

Vue.filter('outlineType', function (value) {
    if (value) {
        return value.replace('LESSON', 'Lesson/Content')
            .replace('QUIZ', 'Assessment/Quiz')
            .replace('CHECKPOINT', 'Checkpoint')
            .replace('MEDIA', 'Video/Image')
            .replace('FORM', 'Form')
            .replace('SURVEY', 'Survey')
            .replace('IFRAME', 'I-Frame/External Content');
    } else {
        return '';
    }
});

Vue.filter('formatSize', function (num) {
    // jacked from: https://github.com/sindresorhus/pretty-bytes
    if (typeof num !== 'number' || isNaN(num)) {
        throw new TypeError('Expected a number');
    }

    var exponent;
    var unit;
    var neg = num < 0;
    var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    if (neg) {
        num = -num;
    }

    if (num < 1) {
        return (neg ? '-' : '') + num + ' B';
    }

    exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
    num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
    unit = units[exponent];

    return (neg ? '-' : '') + num + ' ' + unit;
});
